import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Tab } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import Page from '../Page';
import FeathrLiteOnboardingCard from './FeathrLiteOnboarding/FeathrLiteOnboardingCard';
import GrowthCreditsQA from './GrowthCreditsQA';
import PackageSwitcher from './PackageSwitcher/PackageSwitcher';

type TDevQATab = 'package-switcher' | 'feathr-lite-onboarding' | 'growth-credits';

function DevelopmentQAPage(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const { tab } = useParams<{ tab?: TDevQATab }>();
  const [isResetting, setIsResetting] = useState(false);

  const activeTab: TDevQATab = tab ?? 'package-switcher';

  const tabs = [
    <Tab
      exact={true}
      key={'package-switcher'}
      link={localUrl('/development-qa')}
      title={t('Package Switcher')}
    />,
    <Tab
      exact={true}
      key={'feathr-lite-onboarding'}
      link={localUrl('/development-qa/feathr-lite-onboarding')}
      title={t('Feathr Lite Onboarding')}
    />,
    <Tab
      exact={true}
      key={'growth-credits'}
      link={localUrl('/development-qa/growth-credits')}
      title={t('Growth Credits')}
    />,
  ];

  return (
    <Page tabs={tabs} title={t('Development & QA')}>
      {activeTab === 'package-switcher' && <PackageSwitcher isResetting={isResetting} />}
      {activeTab === 'feathr-lite-onboarding' && (
        <FeathrLiteOnboardingCard isResetting={isResetting} setIsResetting={setIsResetting} />
      )}
      {activeTab === 'growth-credits' && <GrowthCreditsQA />}
    </Page>
  );
}

export default DevelopmentQAPage;
